/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
    spacing: {
        minWidth: theme.spacing.unit * 2,
        flex: "1 1 auto",
        height: "100%",
        backgroundColor: "#EEE",
    },
    raster: {},
});

class DaySpacer extends React.Component {

    render() {
        const {classes} = this.props;
        return <div className={classes.spacing} {...this.props}/>
    }
}

DaySpacer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DaySpacer);